
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/help/articles",
      function () {
        return require("private-next-pages/_sites/[site]/help/articles/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/help/articles"])
      });
    }
  